import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import { Skeleton } from "atoms/skeleton/Skeleton";
import TopNav from "molecules/navbars/TopNav";
import { useNavigate } from "react-router-dom";

export const AccountDestinationSkeleton = ({ title }: { title: string }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-one">
      <TopNav
        startIconSVG={ChevronLeft}
        onStartIconClick={() => navigate(-1)}
        showHeaderItems={false}
      >
        <h1 className="text-sub2 uppercase text-primary">{title}</h1>
      </TopNav>
      <div className="flex flex-col gap-3 px-4 py-6 desk:px-0 desk:py-0">
        <Skeleton className="h-8 w-48" />
        {[0, 1, 2, 3, 4].map((row) => (
          <div key={row} className="flex gap-3 rounded-xl bg-white p-4">
            <Skeleton className="h-6 w-6 rounded-full" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-5 w-3/4" />
              <Skeleton className="h-4 w-1/2" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
